import React from 'react';
import { motion } from 'framer-motion';
import { CameraIcon, ListIcon, ClockIcon, FootprintsIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { INTERIOR_FEATURES } from './salesData';
import { INTERIOR_PAGE_IMAGE_URL, INTERIOR_STEPS_IMAGE_URL, INTERIOR_DEVICE_IMAGE_URL } from '../utils/headMeta';
const FEATURE_ICONS = [CameraIcon, ListIcon, ClockIcon, FootprintsIcon];
export function InteriorSection() {
  return <section id="interior" className="bg-white py-12 sm:py-16" data-id="element-128" data-mp="9d9glzzvmydb">
      <div className="mx-auto max-w-5xl px-5" data-id="element-129" data-mp="9fnai5itm4ja">
        <div className="text-center" data-id="element-130" data-mp="3rsbp525ijee3">
          <SectionTag className="bg-cream" data-id="element-131" data-mp="3rra3y4us9bin">Por dentro</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[24ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[32ch] sm:text-[2.2rem]" data-id="element-132" data-mp="3vs2c0urx5adc">
            No es un PDF lleno de texto. Es una{' '}
            <span className="mark-yellow" data-id="element-133" data-mp="s5brsvtr1mg6">colección visual</span>.
          </h2>
          <p className="mx-auto mt-4 max-w-[46ch] font-sans text-[0.92rem] leading-relaxed text-taupe sm:max-w-[56ch] sm:text-[1rem]" data-id="element-134" data-mp="2x6j3u1xaa1kh">
            Cada receta está diseñada como una página de revista gastronómica: foto del plato,
            ingredientes, tiempo, porciones y preparación paso a paso.
          </p>
        </div>

        {/* Imagen principal grande + dos apoyos: la vista interior es lo que decide la compra. */}
        <div className="mt-8 grid gap-2.5 lg:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)]" data-id="element-135" data-mp="3fybwfv8fxkro">
          <figure className="overflow-hidden rounded-3xl bg-cream" data-id="element-136" data-mp="3budxbkj489ym">
            <img src={INTERIOR_PAGE_IMAGE_URL} alt="Página interior con la foto del plato, la lista de ingredientes y el paso a paso" loading="lazy" decoding="async" width={1200} height={900} className="h-[220px] w-full object-cover sm:h-[400px] lg:h-full" data-id="element-137" data-mp="3ptdkenqzcgso" />
          </figure>

          <div className="grid gap-2.5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-138" data-mp="3qkc1fxk16whd">
            <figure className="overflow-hidden rounded-3xl bg-cream" data-id="element-139" data-mp="3vinbo9e8n904">
              <img src={INTERIOR_DEVICE_IMAGE_URL} alt="Las recetas abiertas en una tablet y un celular sobre la mesada" loading="lazy" decoding="async" width={1200} height={800} className="h-[160px] w-full object-cover sm:h-[195px]" data-id="element-140" data-mp="3vix1nwza9g5t" />
            </figure>
            <figure className="overflow-hidden rounded-3xl bg-cream" data-id="element-141" data-mp="iak7yma6fbkh">
              <img src={INTERIOR_STEPS_IMAGE_URL} alt="Preparación paso a paso con ingredientes frescos sobre la mesada" loading="lazy" decoding="async" width={1200} height={900} className="h-[160px] w-full object-cover sm:h-[195px]" data-id="element-142" data-mp="n2lf5tshmc3n" />
            </figure>
          </div>
        </div>

        <ul className="mt-2.5 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-143" data-mp="1b7kyri3egd3t">
          {INTERIOR_FEATURES.map((feature, i) => {
          const Icon = FEATURE_ICONS[i] ?? CameraIcon;
          return <motion.li key={feature.title} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.24,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(i, 3) * 0.04
          }} className="rounded-xl border border-stone bg-cream px-3.5 py-3" data-id="element-144" data-mp="11958fhc757vd" data-mpi={i}>
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gold" data-id="element-145" data-mp="1g4l7y1vjpvz5">
                  <Icon className="h-4 w-4 text-charcoal" aria-hidden strokeWidth={2.5} data-id="element-146" data-mp="2cokgbg5y1k59" />
                </span>
                <h3 className="mt-2.5 font-display text-[0.88rem] font-bold leading-tight tracking-tight text-charcoal" data-id="element-147" data-mp="27w0r1lxw90km">
                  {feature.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.79rem] leading-snug text-taupe" data-id="element-148" data-mp="1xe5nafal0xre">
                  {feature.desc}
                </p>
              </motion.li>;
        })}
        </ul>

        <div className="mt-8 flex justify-center" data-id="element-149" data-mp="1nexzsza4vmqk">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-150" data-mp="1nhskmrx279ki" />
        </div>
      </div>
    </section>;
}